import { trackCustomEvent } from 'gatsby-plugin-google-analytics';

class Tracking {
	eventTrack(type, data) {
		trackCustomEvent({ category: type, action: `button: ${data.button}, location: ${data.location}` });
	}
}

export default new Tracking();
